export const collection = {
  sectionId: null,
  loading: false,
  totalPages: 1,
  currentPage: 1,
  maxPage: 1,
  filterMinPrice: '',
  filterMaxPrice: '',
  filterMin: 0,
  filterMax: 0,
  pagesLoaded: 1,

  // Call section render API with data from filter
  async fetchAndRenderCollection(filterData) {
    const filterUrl = this.buildUrlFilter(filterData);

    // Get search term
    let searchUrl = new URL(location.href).searchParams.get("q");
    searchUrl = searchUrl ? `&q=${searchUrl}` : "";

    const urlParams = (filterUrl + searchUrl).replace(/^&/, '');
    history.pushState(null, "", `${window.location.pathname}${urlParams ? '?' + urlParams : ''}`);

    // Listen to popstate event
    window.addEventListener("popstate", () => {
      this.fetchAndRenderCollection(filterData);
    });

    try {
      const response = await fetch(`${window.location.pathname}?section_id=${this.sectionId}${filterUrl}${searchUrl}`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.text();

      const sectionElement = document.getElementById(`shopify-section-${this.sectionId}`);

      if (sectionElement) {
        sectionElement.innerHTML = data;
      }

      this.loading = false;
    } catch (error) {
      console.error("Error:", error);
      this.loading = false;
    }
  },

  // Check if next page is available and inject more products
  async fetchAndRenderPage(direction) {
    // Prevent browser from scrolling down
    history.scrollRestoration = "manual";

    this.loading = true;

    // Update URL to show updated page number
    if (direction === "next") {
      const url = new URL(window.location.href);
      url.searchParams.set("page", this.currentPage + 1);
      window.history.pushState({}, "", url);
    }

    // Get filter data
    const filter = document.querySelector("[js-main-collection='filter']");

    // Get pagination count
    const pageUrl = `&page=${direction === "next" ? this.currentPage + 1 : this.currentPage - 1}`;

    // Get search parameter
    const searchUrl = new URL(location.href).searchParams.get("q")
      ? `&q=${new URL(location.href).searchParams.get("q")}`
      : "";

    // Build fetch url
    let fetchUrl = `${window.location.pathname}?section_id=${this.sectionId}${pageUrl}${searchUrl}`;

    // If filter exists, add filter data to fetch url
    if (filter) {
      const filterData = new FormData(filter);
      const filterUrl = this.buildUrlFilter(filterData);
      fetchUrl += filterUrl;
    }

    // Check if we've reached the last page and we are not loading previous pages
    if (this.currentPage >= this.totalPages && direction !== "previous") {
      this.loading = false;
      return;
    }

    try {
      const response = await fetch(fetchUrl);
      const data = await response.text();

      // Create a new HTML element and set its innerHTML to the fetched data
      const tempElement = document.createElement("div");
      tempElement.innerHTML = data;

      // Find the results within the fetched data
      const fetchedElement = tempElement.querySelector("[js-main-collection='results']");
      const resultsElement = document.querySelector("[js-main-collection='results']");

      // If results are found, append its innerHTML to the existing element on the page
      if (fetchedElement && resultsElement) {
        if (direction === "next") {
          resultsElement.insertAdjacentHTML("beforeend", fetchedElement.innerHTML);
        }

        if (direction === "previous") {
          resultsElement.insertAdjacentHTML("afterbegin", fetchedElement.innerHTML);
        }
      }

      if (direction === "next") {
        this.currentPage += 1;
        this.maxPage += 1;
        this.pagesLoaded += 1;
      } else {
        this.currentPage -= 1;
        const url = new URL(window.location.href);
        url.searchParams.set("page", this.currentPage);
        window.history.pushState({}, "", url);
      }

      this.loading = false;
    } catch (error) {
      console.error("Error:", error);
      this.loading = false;
    }
  },

  // Handle filter change
  handleFilterChange($el) {
    this.loading = true;
    this.currentPage = 1;

    if (!$el) {
      console.error(`Filter form not found.`);
      return;
    }

    const filterData = new FormData($el);

    this.fetchAndRenderCollection(filterData);
  },

  // Handle deleting filters
  handleFilterDelete(filterToReset) {
    this.loading = true;

    const filter = document.querySelector("[js-main-collection='filter']");

    if (!filter) {
      console.error("Filter form not found.");
      return;
    }

    const filterData = new FormData(filter);

    // Remove deleted filter
    filterData.delete(filterToReset);

    // Reset the price filters to their initial values
    if (filterToReset.includes("price")) {
      filterData.delete("filter.v.price.gte");
      filterData.delete("filter.v.price.lte");

      this.filterMinPrice = this.filterMin;
      this.filterMaxPrice = this.filterMax;
    }

    this.fetchAndRenderCollection(filterData);
  },

  // Handle deleting all filters
  handleFilterDeleteAll() {
    this.loading = true;

    const filterData = new FormData();

    this.fetchAndRenderCollection(filterData);
  },

  // Build urlFilter
  buildUrlFilter(filterData) {
    let urlFilter = "";

    for (const [key, value] of filterData.entries()) {
      // Handle non-price filters
      if (!key.includes("price")) {
        urlFilter += `&${key}=${encodeURIComponent(value.toString())}`;
        continue;
      }

      // Handle price filters
      if (
        (key === "filter.v.price.lte" && value < this.filterMax) ||
        (key === "filter.v.price.gte" && value > this.filterMin)
      ) {
        urlFilter += `&${key}=${value}`;
      }
    }

    return urlFilter;
  },

  // Method to scroll to the top of pagination
  scrollToTopOfPagination() {
    const element = document.querySelector('[js-main-collection="section"]');

    if (!element) return;

    element.scrollIntoView({ behavior: "smooth", block: "start" });
  },
};
